var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_43984)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8094 51.2106C30.6445 51.2309 29.4919 50.9692 28.4487 50.4475L18.2326 45.077L15.1648 46.927C13.7096 47.8052 13.7348 49.1537 15.2211 49.9343L29.349 57.3637C30.1132 57.7344 30.9534 57.9189 31.8017 57.9023C32.8061 57.9212 33.7978 57.6742 34.6773 57.1861L48.5142 48.8336C49.9694 47.9535 49.9442 46.607 48.4579 45.8244L45.5221 44.2808L35.6941 50.2133C34.5116 50.8866 33.172 51.2308 31.8133 51.2106",
    fill: "url(#paint0_linear_2171_43984)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5491 36.9296L46.0965 35.6201L40.386 39.1328L39.4158 39.7339L38.4359 40.335L35.762 41.9742C34.5729 42.6583 33.2218 43.0056 31.8522 42.9792C30.6824 42.9976 29.5257 42.7297 28.4817 42.1986L25.4198 40.5652L24.405 40.0247L23.3921 39.4841L17.7514 36.471L15.1746 38.0517C13.7174 38.9455 13.7426 40.3174 15.2328 41.1117L18.1764 42.6729L19.1912 43.2134L20.2099 43.7598L29.4034 48.664C30.1639 49.0434 31.0033 49.2354 31.8522 49.2241C32.8597 49.2438 33.8543 48.9932 34.7336 48.4981L43.5721 43.0768L44.5539 42.4758L45.5338 41.8747L48.6015 39.9934C50.0607 39.0997 50.0355 37.7277 48.5453 36.9335",
    fill: "url(#paint1_linear_2171_43984)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5491 28.907L34.3844 21.4913C33.6175 21.1205 32.7747 20.936 31.924 20.9527C30.918 20.9341 29.9247 21.1803 29.0425 21.667L15.1746 30.0135C13.7174 30.8917 13.7426 32.2461 15.2328 33.0267L17.6874 34.3069L18.7022 34.8377L19.7112 35.3685L25.3558 38.327L26.3706 38.8578L27.3893 39.3925L29.3976 40.4424C30.1625 40.8132 31.0031 40.999 31.8522 40.9849C32.8582 41.0037 33.8516 40.7575 34.7336 40.2707L36.3946 39.2695L37.3648 38.6841L38.335 38.0986L44.0766 34.6484L45.0468 34.0629L46.0286 33.4775L48.6035 31.9163C50.0626 31.0381 50.0374 29.6896 48.5472 28.909",
    fill: "url(#paint2_linear_2171_43984)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6524 23.9835C74.2122 23.9636 73.7724 24.0311 73.3581 24.1822C72.9439 24.3332 72.5632 24.5649 72.238 24.8639C71.9128 25.1629 71.6493 25.5234 71.4626 25.9249C71.2759 26.3263 71.1697 26.7608 71.15 27.2035V30.4606H78.6535V35.9424H71.15V56.6283H64.3955V35.9424H59.8939V30.4606H64.3955V26.7196C64.3955 21.4876 68.8972 18.0022 73.9034 18.0022C76.1898 17.9526 78.4144 18.7507 80.1534 20.2445L77.6445 24.9788C76.7428 24.3986 75.7106 24.0556 74.6427 23.9816",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.62 30.2476V56.4816H101.441L100.454 53.4841H99.7163C98.7306 54.7331 96.5108 56.7334 92.0712 56.7334C85.1635 56.7334 81.7096 51.7356 81.7096 44.4896V30.2437H88.8657V42.7333C88.8657 45.9825 89.1121 50.4788 93.5537 50.4788C95.7735 50.4788 99.4738 49.2298 99.4738 42.4776V30.2476H106.62Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.284 35.5166C119.033 35.5166 118.033 36.5197 118.033 37.7745C118.033 39.5309 120.284 40.0324 122.033 40.5339C126.783 41.537 131.54 43.0416 131.54 48.5605C131.54 54.0793 127.041 57.0905 121.542 57.0905C115.544 57.0905 110.796 53.328 110.546 47.8072H117.034C117.156 48.8968 117.692 49.8968 118.53 50.5975C119.369 51.2983 120.445 51.6453 121.532 51.5658C124.281 51.5658 124.78 50.0592 124.78 49.0562C124.78 47.05 123.034 46.5485 121.031 46.0469C118.032 45.2956 111.283 44.0388 111.283 38.0184C111.283 32.7494 116.285 30.2417 121.284 30.2417C127.281 30.2417 131.032 33.7544 131.28 38.2682H124.782C124.782 37.0154 124.037 35.5108 121.289 35.5108",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.905 45.2997H140.827C141.566 49.2769 144.789 50.7639 147.764 50.7639C148.707 50.8098 149.647 50.6311 150.508 50.2425C151.369 49.8539 152.127 49.2663 152.72 48.5275H159.408C158.51 50.9617 156.885 53.0565 154.755 54.5241C152.626 55.9918 150.097 56.7602 147.516 56.7238C145.788 56.7213 144.077 56.3764 142.482 55.709C140.886 55.0417 139.437 54.0648 138.217 52.8341C136.997 51.6035 136.03 50.1433 135.371 48.5368C134.713 46.9303 134.375 45.209 134.377 43.4712C134.377 43.3326 134.377 43.194 134.377 43.0555C134.269 39.6769 135.5 36.3933 137.798 33.9271C140.097 31.4608 143.275 30.0138 146.635 29.9043C146.846 29.8965 147.057 29.8965 147.269 29.9043C153.96 29.9043 160.896 34.6269 159.905 45.3212V45.2997ZM141.322 40.1009H152.964C152.711 38.8557 152.021 37.7437 151.02 36.968C150.019 36.1923 148.773 35.8047 147.512 35.8759C146.159 35.7859 144.815 36.1526 143.693 36.918C142.571 37.6833 141.735 38.8035 141.318 40.1009",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2171_43984",
    x1: 33.3067,
    y1: 21.1329,
    x2: 33.3067,
    y2: 56.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2171_43984",
    x1: 31.8017,
    y1: 22.1742,
    x2: 31.8017,
    y2: 57.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1FFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF16D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2171_43984",
    x1: 6465320,
    y1: -1756950,
    x2: 6465320,
    y2: -1753240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_43984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 40,
    fill: "white",
    transform: "translate(14 18)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/fuse.7d866daff8c22e36e30b95fddf2e0acf.svg";
export { ForwardRef as ReactComponent };